(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[836],{

/***/ 7841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d": function() { return /* binding */ OptimizedImage; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(2269);
// EXTERNAL MODULE: ../../node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(8421);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../packages/design-system/next-image/src/index.tsx


var _excluded = ["appEnv"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/*
    Based on Example laid out by Cloudflare:
    https://developers.cloudflare.com/images/image-resizing/integration-with-frameworks/
*/



var normalizeSrc = function normalizeSrc(src) {
  return src.startsWith('/') ? src.slice(1) : src;
};

var cloudflareLoader = function cloudflareLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  var params = ['fit=scale-down', "width=".concat(width)];

  if (quality) {
    params.push("quality=".concat(quality));
  }

  var paramsString = params.join(',');
  return "/cdn-cgi/image/".concat(paramsString, "/").concat(normalizeSrc(src));
};

var localLoader = function localLoader(_ref2) {
  var src = _ref2.src;
  return "/".concat(normalizeSrc(src));
};

var cloudflareEnvs = ['stage', 'production', 'sandbox2', 'eks-stage'];
var localEnvs = ['local', 'test'];
var NextOptimizedImage = function NextOptimizedImage(_ref3) {
  var appEnv = _ref3.appEnv,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref3, _excluded);

  var imageLoader = (0,react.useMemo)(function () {
    return cloudflareEnvs.includes(appEnv) ? cloudflareLoader : localEnvs.includes(appEnv) ? localLoader : undefined;
  }, [appEnv]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), _objectSpread({
    loader: imageLoader
  }, rest));
};
;// CONCATENATED MODULE: ../../packages/design-system/next-image/index.ts

/* harmony default export */ var next_image = (NextOptimizedImage);
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(8199);
;// CONCATENATED MODULE: ./components/molecules/OptimizedImage/index.tsx


function OptimizedImage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OptimizedImage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OptimizedImage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OptimizedImage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var OptimizedImage = function OptimizedImage(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(next_image, OptimizedImage_objectSpread({
    appEnv: env/* APP_ENV */.Wi
  }, props));
};

/***/ }),

/***/ 6751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ Shell; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/molecules/NavBar/styled.ts

var styled_NavBar = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
  displayName: "styled__NavBar",
  componentId: "sc-1pq2k3n-0"
})(["", " > div{", "}a{", "}"], {
  "position": "sticky",
  "zIndex": "10",
  "display": "grid",
  "width": "100%",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "opacity": "0.95",
  "gridTemplateRows": "72px",
  "top": "0",
  "height": "72px",
  "@media (min-width: 1024px)": {
    "scrollSnapAlign": "start"
  }
}, {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "paddingLeft": "1.5rem",
  "paddingRight": "1.5rem",
  "@media (min-width: 1024px)": {
    "paddingLeft": "2.5rem",
    "paddingRight": "2.5rem"
  }
}, {
  "textDecorationLine": "none"
});
var Logo = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "styled__Logo",
  componentId: "sc-1pq2k3n-1"
})(["", " svg{", " path{fill:url('#custodia-mark_svg__a');}}span{", "}"], {
  "display": "flex",
  "alignItems": "center",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "height": "2.5rem"
}, {
  "marginLeft": "0.5rem",
  "fontWeight": "700"
});
var NavItemTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__NavItemTitle",
  componentId: "sc-1pq2k3n-2"
})(function (_ref) {
  var isSelected = _ref.isSelected;
  return [{
    "paddingLeft": "0.75rem",
    "paddingRight": "0.75rem",
    "paddingTop": "0.25rem",
    "paddingBottom": "0.25rem",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    ":hover": {
      "opacity": "0.7"
    }
  }, isSelected && {
    "fontWeight": "700"
  }];
});
var DesktopRightContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__DesktopRightContent",
  componentId: "sc-1pq2k3n-3"
})(["", ""], {
  "display": "flex"
});
var DesktopNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__DesktopNavItems",
  componentId: "sc-1pq2k3n-4"
})(["", ""], {
  "display": "none",
  "listStyleType": "none",
  "gridTemplateColumns": "repeat(3, auto)",
  "alignItems": "center",
  "gap": "3rem",
  "fontSize": "1.25rem",
  "lineHeight": "1.75rem",
  "@media (min-width: 1024px)": {
    "display": "grid"
  }
});
var MobileNavItems = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styled__MobileNavItems",
  componentId: "sc-1pq2k3n-5"
})(function (_ref2) {
  var menuOpen = _ref2.menuOpen;
  return [{
    "display": "none",
    "listStyleType": "none",
    "alignItems": "center",
    "paddingLeft": "0.5rem",
    "paddingRight": "0.5rem",
    "paddingTop": "1rem",
    "paddingBottom": "1rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "marginTop": "-0.1rem"
  }, {
    "position": "sticky",
    "left": "0px",
    "zIndex": "10",
    "height": "calc(100vh - 72px + 0.1rem)",
    "width": "100%",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(0 0 0 / var(--tw-bg-opacity))",
    "top": "72px"
  }, menuOpen && {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "gap": "1.75rem",
    "fontSize": "1.25rem",
    "lineHeight": "1.75rem",
    "@media (min-width: 1024px)": {
      "display": "none"
    }
  }];
});
var MobileMenuSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileMenuSpacer",
  componentId: "sc-1pq2k3n-6"
})(["", ""], {
  "width": "100%",
  "flexGrow": "1"
});
var MobileSubscribeButtonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MobileSubscribeButtonWrapper",
  componentId: "sc-1pq2k3n-7"
})(["", " button{", "}"], {
  "width": "100%",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.5rem",
  "paddingBottom": "1rem"
}, {
  "display": "block",
  "width": "100%"
});
var DarkModeButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__DarkModeButton",
  componentId: "sc-1pq2k3n-8"
})(["", ""], {
  "marginLeft": "1.5rem",
  "display": "none",
  "@media (min-width: 1024px)": {
    "display": "block"
  }
});
var MenuButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "styled__MenuButton",
  componentId: "sc-1pq2k3n-9"
})(["", ""], {
  "padding": "0.25rem",
  "@media (min-width: 1024px)": {
    "display": "none"
  }
});
// EXTERNAL MODULE: ../../node_modules/react-icons/vsc/index.mjs
var vsc = __webpack_require__(8097);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ./assets/custodia-mark.svg
var custodia_mark = __webpack_require__(5426);
// EXTERNAL MODULE: ./components/molecules/ColoredBorderWrapper/styled.ts
var styled = __webpack_require__(3419);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/ColoredBorderWrapper/index.tsx




var ColoredBorderWrapper = function ColoredBorderWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [children, /*#__PURE__*/(0,jsx_runtime.jsx)(styled/* Border */.O, {})]
  });
};
;// CONCATENATED MODULE: ./components/molecules/NavBar/index.tsx









var ROUTES = [{
  title: 'Avit',
  href: '/avit'
}, {
  title: 'Press',
  href: '/press'
}, {
  title: 'About',
  href: '/about'
}];
var NavBar = function NavBar() {
  var _useState = (0,react.useState)(false),
      menuOpen = _useState[0],
      setMenuOpen = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styled_NavBar, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: '/',
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Logo, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(custodia_mark/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            children: "Custodia"
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DesktopRightContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MenuButton, {
          onClick: function onClick() {
            return setMenuOpen(!menuOpen);
          },
          "aria-expanded": !!menuOpen,
          "aria-label": "Menu",
          "aria-controls": "nav-menu",
          children: menuOpen ? /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscClose */.ven, {
            size: 25
          }) : /*#__PURE__*/(0,jsx_runtime.jsx)(vsc/* VscThreeBars */.QEj, {
            size: 25
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DesktopNavItems, {
          children: ROUTES.map(function (r) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
              href: r.href,
              title: r.title
            }, r.href);
          })
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MobileNavItems, {
      menuOpen: menuOpen,
      id: 'nav-menu',
      children: [ROUTES.map(function (r) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(NavItem, {
          href: r.href,
          title: r.title
        }, r.href);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MobileMenuSpacer, {})]
    })]
  });
};

var NavItem = function NavItem(_ref) {
  var href = _ref.href,
      title = _ref.title,
      external = _ref.external;
  var router = (0,next_router.useRouter)();
  var isCurrentRoute = !external && (router.route === href || // highlight "Avit" on /avit and any nested page (e.g. the redemption page)
  href === '/avit' && router.route.startsWith('/avit/'));

  var content = /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    children: isCurrentRoute ? /*#__PURE__*/(0,jsx_runtime.jsx)(ColoredBorderWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
        isSelected: isCurrentRoute,
        children: title
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(NavItemTitle, {
      isSelected: isCurrentRoute,
      children: title
    })
  });

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: external ? /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
      href: href,
      children: content
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: href,
      children: content
    })
  });
};
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(2779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/design-system/footer/index.ts + 3 modules
var footer = __webpack_require__(2890);
// EXTERNAL MODULE: ./components/molecules/Shell/styled.ts
var Shell_styled = __webpack_require__(564);
// EXTERNAL MODULE: ./hooks/useIsBrowser.ts
var useIsBrowser = __webpack_require__(9612);
// EXTERNAL MODULE: ../../packages/design-system/cookie-banner/index.tsx + 4 modules
var cookie_banner = __webpack_require__(86);
;// CONCATENATED MODULE: ./components/molecules/Shell/index.tsx










var Shell = function Shell(_ref) {
  var _ref$enableSnapPoints = _ref.enableSnapPoints,
      enableSnapPoints = _ref$enableSnapPoints === void 0 ? false : _ref$enableSnapPoints,
      children = _ref.children;
  var isBrowser = (0,useIsBrowser/* useIsBrowser */.E)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Shell_styled/* ShellWrapper */.r, {
      className: classnames_default()({
        dark: true
      }),
      enableSnapPoints: enableSnapPoints,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Shell_styled/* ContentWrapper */.v, {
        children: children
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(footer/* default */.ZP, {}), isBrowser && /*#__PURE__*/(0,jsx_runtime.jsx)(cookie_banner/* default */.Z, {})]
    })
  });
};

/***/ }),

/***/ 5509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ dba; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./components/molecules/Seo/index.tsx
var Seo = __webpack_require__(1424);
// EXTERNAL MODULE: ./components/molecules/Shell/index.tsx + 3 modules
var Shell = __webpack_require__(6751);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(1895);
;// CONCATENATED MODULE: ./components/screens/dba/styles.ts

var ScreenWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__ScreenWrapper",
  componentId: "sc-qpe8dc-0"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto",
  "display": "flex",
  "maxWidth": "790px",
  "flexDirection": "column",
  "paddingLeft": "2rem",
  "paddingRight": "2rem"
});
;// CONCATENATED MODULE: ./components/molecules/Maps/DbaMap/styled.ts

var HeaderTextWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__HeaderTextWrapper",
  componentId: "sc-w2t50z-0"
})(["", " h1{", "}h2{", "}"], {
  "display": "flex",
  "flexDirection": "column",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
}, {
  "marginBottom": "1.5rem",
  "marginTop": "4rem",
  "textAlign": "left",
  "fontSize": "2.25rem",
  "lineHeight": "2.5rem"
}, {
  "marginBottom": "2.5rem",
  "textAlign": "left",
  "fontSize": "1.5rem",
  "lineHeight": "2rem"
});
;// CONCATENATED MODULE: ./components/molecules/Maps/MapBullets/styled.ts

var KeyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__KeyWrapper",
  componentId: "sc-kwckhb-0"
})(["", " div{", "}"], {
  "marginTop": "2.5rem",
  "marginBottom": "5rem",
  "display": "flex",
  "flexDirection": "column",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-y-reverse": "0",
    "marginTop": "calc(0.5rem * calc(1 - var(--tw-space-y-reverse)))",
    "marginBottom": "calc(0.5rem * var(--tw-space-y-reverse))"
  }
}, {
  "display": "flex",
  "> :not([hidden]) ~ :not([hidden])": {
    "--tw-space-x-reverse": "0",
    "marginRight": "calc(1rem * var(--tw-space-x-reverse))",
    "marginLeft": "calc(1rem * calc(1 - var(--tw-space-x-reverse)))"
  }
});
var Bullet = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__Bullet",
  componentId: "sc-kwckhb-1"
})(["", " ", ""], function (_ref) {
  var color = _ref.color;
  return color === 'yellow' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 196 37 / var(--tw-bg-opacity))"
  } : color === 'blue' ? {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(126 161 222 / var(--tw-bg-opacity))"
  } : {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(107 114 128 / var(--tw-bg-opacity))"
  };
}, {
  "marginTop": "0.375rem",
  "height": "1rem",
  "width": "1rem",
  "borderRadius": "9999px"
});
var BulletText = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "styled__BulletText",
  componentId: "sc-kwckhb-2"
})(["", ""], {
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))"
});
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ./components/molecules/Maps/MapBullets/index.tsx




var MapBullets = function MapBullets(_ref) {
  var bullets = _ref.bullets;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(KeyWrapper, {
    children: bullets.map(function (_ref2) {
      var color = _ref2.color,
          text = _ref2.text;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(KeyItem, {
        color: color,
        text: text
      }, color);
    })
  });
};

var KeyItem = function KeyItem(_ref3) {
  var color = _ref3.color,
      text = _ref3.text;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Bullet, {
        color: color
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BulletText, {
      children: text
    })]
  });
};
;// CONCATENATED MODULE: ./components/molecules/Maps/MapAndBullets/styled.ts

var MapWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styled__MapWrapper",
  componentId: "sc-1amweq-0"
})(["", ""], {
  "marginLeft": "auto",
  "marginRight": "auto"
});
// EXTERNAL MODULE: ./components/molecules/OptimizedImage/index.tsx + 2 modules
var OptimizedImage = __webpack_require__(7841);
;// CONCATENATED MODULE: ./components/molecules/Maps/MapAndBullets/index.tsx






var MapAndBullets = function MapAndBullets(_ref) {
  var bullets = _ref.bullets,
      mapSrc = _ref.mapSrc;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MapWrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(OptimizedImage/* OptimizedImage */.d, {
        src: mapSrc,
        width: 680,
        height: 442
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MapBullets, {
      bullets: bullets
    })]
  });
};
// EXTERNAL MODULE: ./config/env.ts
var env = __webpack_require__(8199);
;// CONCATENATED MODULE: ./utils/images.ts
 // getBustTheCacheImageSrc is to be used to specify an image source we want
// to bust the cache for. For ex: our product maps that update periodically.
// We don't care to do this for most slow changing images like the background
// assets dispersed across www

var getBustTheCacheImageSrc = function getBustTheCacheImageSrc(path) {
  var url = new URL(path, 'https://custodiabank.com');
  url.searchParams.append('version', env/* GIT_HASH */.wP);
  return url.pathname + url.search;
};
;// CONCATENATED MODULE: ./components/molecules/Maps/DbaMap/index.tsx






var BULLETS = [{
  color: 'yellow',
  text: 'We operate as Custodia Bank, Inc. in the following states and territories: AL, AZ, CA, CO, DC, FL, ID, KS, MA, MO, NH, SC, WY'
}, {
  color: 'blue',
  text: 'We operate as Custodia Digital Services in the following states: AK, GA, MD, MN, MS, MT, ND, NE, PA, RI, SD, TX, UT, VT (non-money transmission services only), WA, WI, WV'
}, {
  color: 'gray',
  text: 'Custodia is not currently operating in these states'
}];
var DbaHeader = function DbaHeader() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(HeaderTextWrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h1", {
      children: "Operating Information"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("h2", {
      children: ["Custodia Bank, Inc. operates as Custodia Digital", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Services in certain US states."]
    })]
  });
};
var DbaMap = function DbaMap() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(MapAndBullets, {
    bullets: BULLETS,
    mapSrc: getBustTheCacheImageSrc("/images/maps/dba_map.png")
  });
};
;// CONCATENATED MODULE: ./components/screens/dba/index.tsx






var Screen = function Screen() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Shell/* Shell */.N, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ScreenWrapper, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DbaHeader, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(DbaMap, {})]
    })
  });
};
// EXTERNAL MODULE: ./config/index.ts
var config = __webpack_require__(9597);
;// CONCATENATED MODULE: ./pages/dba.tsx








var Page = function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* Seo */.p, {
      title: "Operating Information | ".concat(config/* site.title */.l.title)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Screen, {})]
  });
};

/* harmony default export */ var dba = (Page);

/***/ }),

/***/ 1612:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dba",
      function () {
        return __webpack_require__(5509);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [946,250,421,456,774,888,179], function() { return __webpack_exec__(1612); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);